// extracted by mini-css-extract-plugin
export var bodyRow = "_gy-d";
export var cardColumns = "_gy-e";
export var ellipsesOverflow = "_gy-2";
export var flatBottomCorners = "_gy-3";
export var flatTopCorners = "_gy-4";
export var headerActionsDropdown = "_gy-f";
export var headerBottomRow = "_gy-c";
export var headerTopRow = "_gy-b";
export var orderDetailsWrapper = "_gy-0";
export var orderInfoContainer = "_gy-1";
export var productDetails = "_gy-9";
export var productImage = "_gy-5";
export var responsiveTable = "_gy-8";
export var shipmentContainer = "_gy-a";
export var tableBottomLeft = "_gy-6";
export var tableBottomRight = "_gy-7";